import React from "react";
import styled, { keyframes } from "styled-components";

import Skeleton from "../../components/layout/skeleton";
import { colors, breakpoints } from "../../../theme";
import { DISPLAYED_PROJECTS } from "../../utils/constants/projects";
import {
  ProjectCardContainer,
  ProjectCoverSection,
  CoverContainer,
  ProjectInfoSection,
  ButtonRow,
} from "./styles";

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
`;

const SkeletonCover = styled(CoverContainer)`
  background-color: ${colors.grey.medium};
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

const TitleBones = styled.div`
  margin-block: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    width: 400px;
  }
`;

const TitleBone = styled(Skeleton)`
  height: 22px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 28px;
  }
`;

const RolesBoneWrap = styled.div`
  margin-block: 1rem 2rem;
`;

const ButtonBone = styled(Skeleton)`
  margin-block: 6px;
  width: 100%;
  height: 44px;
  border-radius: 18px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 40px;
    width: ${(props) => props.$width || "140px"};
    margin-inline: 4px 8px;
  }
`;

const ProjectCardSkeleton = ({ index, buttonCount }) => {
  const isAlternate = index % 2 === 0;

  return (
    <ProjectCardContainer isAlternate={isAlternate} bgColor={colors.surface}>
      <ProjectCoverSection isAlternate={isAlternate}>
        <SkeletonCover />
      </ProjectCoverSection>
      <ProjectInfoSection>
        <Skeleton height="14px" width="60%" />
        <TitleBones>
          <TitleBone width="100%" />
          <TitleBone width="92%" />
          <TitleBone width="70%" />
        </TitleBones>
        <RolesBoneWrap>
          <Skeleton height="14px" width="45%" />
        </RolesBoneWrap>
        <ButtonRow>
          <ButtonBone $width="140px" />
          {buttonCount > 1 ? <ButtonBone $width="120px" /> : null}
        </ButtonRow>
      </ProjectInfoSection>
    </ProjectCardContainer>
  );
};

const ProjectCardsSkeleton = () => (
  <div aria-hidden>
    {DISPLAYED_PROJECTS.map((project, index) => (
      <ProjectCardSkeleton
        key={project.slug}
        index={index}
        buttonCount={project.links?.project ? 2 : 1}
      />
    ))}
  </div>
);

export default ProjectCardsSkeleton;
